import './EditListingModalStyle.less';

import { CtaButton, Modal } from '@opendoor/bricks';
import isNil from 'lodash/isNil';
import React from 'react';

import { trackEvent } from '../../api/analytics';
import ListingTypeAheadInput, { IListingTypeAheadOption } from '../common/ListingTypeAheadInput';

export interface IEditListingModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onSubmit: (listingSlug: string) => void;
}

interface IEditListingModalState {
  propertyAddress: IListingTypeAheadOption;
}

export default class EditListingModal extends React.PureComponent<
  IEditListingModalProps,
  IEditListingModalState
> {
  public state = {
    propertyAddress: {} as IListingTypeAheadOption,
  };

  public render(): JSX.Element {
    const { isOpen, onRequestClose } = this.props;
    const { propertyAddress } = this.state;

    return (
      <Modal isOpen={isOpen} maxWidth={800} onRequestClose={onRequestClose}>
        <div className="od-edit-listing-modal">
          <h5>Enter property address</h5>
          <p>Property address</p>
          <div className="listing-input">
            <ListingTypeAheadInput
              name={'listing'}
              onSelect={(name, newListing) => this.setState({ propertyAddress: newListing })}
              placeholderText="123 Main St."
              invalidUserInputMessage="Please enter a valid address"
            />
          </div>
          <CtaButton
            actionText="Update address"
            disabled={isNil(propertyAddress) || isNil(propertyAddress.slug)}
            onClick={() => this.submitListingChange(propertyAddress.slug)}
          />
        </div>
      </Modal>
    );
  }

  private submitListingChange(slug) {
    this.props.onSubmit(slug);
    trackEvent('resale-offer-portal', 'click', 'submit-edit-listing', {
      listing_slug: slug,
    });
  }
}
